import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const AndroidCentral: Site = {
  id: 'androidcentral',
  logo: 'svg/androidcentral.svg',
  label: 'Android Central',
  analyticsName: 'ac',
  hostname: 'androidcentral.com',
  platform: 'responsive',
  selector: `${responsiveVanillaSelector}, article a`,
};
